import React from "react";

// A table cell in content data (blog posts, grammar points): plain text, or a
// list of parts where `{ strong }` marks the piece to emphasise - used to
// highlight the one kana that moves between verb forms (売 + ら, り, る, れ, ろ).
export type TableCellPart = string | { strong: string };
export type TableCellValue = string | TableCellPart[];

export function tableCellText(cell: TableCellValue): string {
    if (typeof cell === "string") return cell;
    return cell.map((part) => (typeof part === "string" ? part : part.strong)).join("");
}

export default function TableCell({ cell }: { cell: TableCellValue }) {
    if (typeof cell === "string") return <>{cell}</>;
    return (
        <>
            {cell.map((part, index) =>
                typeof part === "string" ? (
                    <React.Fragment key={index}>{part}</React.Fragment>
                ) : (
                    <strong key={index}>{part.strong}</strong>
                )
            )}
        </>
    );
}
